import gql from "graphql-tag";


export const GET_OTP = gql`
    query SendPassword($username: String!) {
        send_password(username: $username) {
            error
        }
    }
`;